export const getXapValue = val => ({
  url: '/kjarni/api/v2/XapValues',
  method: 'GET',
  params: {
    $filter: `XapValueName eq '${val}'`,
  },
});

export const getEntries = (dateFrom, dateTo, masterId, cancelToken) => ({
  url: '/kjarni/api/v2/EmployeeDetailApprovalRequests/RequestsByPeriod',
  method: 'POST',
  data: {
    dateFrom,
    dateTo,
  },
  cancelToken,
});



// WEBPACK FOOTER //
// ./src/sites/vacationApprovals/api.js